<template>
  <div id="remark" class="evaluate-wrap" v-if="remarkItemList.length">
    <!-- 标题 -->
    <v-list-view
      name="评价"
      :sub-name="totalNums"
      :type="3"
      :right-text="likePercentChange"
      right-icon="arrow-right-v3"
      @click="showRemarkList(remarkItemList[0])"
    >
      <!-- 评价标签 -->
      <div class="r-labels" v-if="labelsList.length">
        <ul>
          <li
            :key="index"
            tabindex="0"
            v-for="(item, index) in labelsList"
            @click="filterRemarkList(item.tagId, item.tagName, index)"
            v-track="{
              act: 'show',
              params: {
                cfrom: '157|003|02|077',
                event_id: '157|003|02|077',
                position: index,
                sku_id: skuId,
                tag_content: item.tagName
              }
            }"
          >
            <span>{{ item.tagName }} {{item.evaluateNum | formatLabelNum }}</span>
            <div :aria-label="`第${index + 1}个，共${labelsList.length}个`"></div>
          </li>
        </ul>
      </div>

      <!-- 用户评价信息（最多1条） -->
      <div
        class="remark-container"
        v-for="(remarkItem, index) in remarkItemList"
        role="region"
        :key="index"
        v-track="{
          act: 'show',
          params: {
            cfrom: '157|002|02|077',
            event_id: '157|002|02|077',
            page_name: 1,
            sku_id: skuId,
            comment_id: remarkItem.commentId,
            comment_type: remarkItem.hasVideo ? 1 : 2,
            isno_tag: labelsList.length ? 1 : 2,
            position: index
          }
        }"
      >
        <div tabindex="0" @click="showRemarkList(remarkItem, index)">
          <!-- 用户信息 -->
          <div class="user-info">
            <!-- 用户头像 -->
            <img aria-hidden="true" v-lazy="remarkItem.memberAvatar" alt="" />
            <!-- 用户姓名和商品型号 -->
            <div>
              <div class="detail">
                <span class="name">{{ remarkItem.nickName }}</span>
                <i class="level-icon" :aria-label="remarkItem.memberLevelName">
                  <img class="level-icon-img" :src="remarkItem.levelIconWithTextUrl" :alt="remarkItem.memberLevelName">
                </i>
              </div>
              <div class="model" v-text="remarkItem.specItem"></div>
            </div>
            <!-- 评分五角星 -->
            <div class="rate" :aria-label="`${remarkItem.score}星评价`">
              <rate :score="remarkItem.score" :gradientFlag="false"></rate>
            </div>
          </div>
          <!-- 评论文字信息 -->
          <div class="des" v-if="remarkItem&&remarkItem.content">
            <p v-html="remarkItem.content.replace('\n', '')"></p>
          </div>
        </div>

        <!-- 图片信息 -->
        <div class="img-box" v-if="remarkItem.commentListPics && remarkItem.commentListPics.length"  @click="showRemarkList(remarkItemList[0])">
          <ul class="img-list">
            <li
              class="comment-img"
              v-for="(item, pindex) in remarkItem.commentListPics.slice(0,3)"
              tabindex="0"
              :key="pindex"
              @click.stop="showPopClick(pindex, remarkItem, item)"
            >
              <img v-lazy="item.smallPic" alt="图片" />
              <template v-if="item.videoUrl && isAppSupportVideo">
                <div class="video-play" aria-label="播放视频"></div>
                <div class="video-time" :aria-label="`视频时长${item.videoTime / 1000}秒`">
                  {{ item.videoTime | formatTime }}
                </div>
              </template>
              <div :aria-label="`第${pindex + 1}张，共${remarkItem.commentListPics.length}张`"></div>
            </li>
          </ul>
          <div class="total" v-if="remarkItem.commentListPics.length > 3" aria-hidden="true">
            <span>+{{ remarkItem.commentListPics.length - 3 }}张</span>
          </div>
        </div>
      </div>
    </v-list-view>
    <div class="head-line border1px" v-if="!isLottery"></div>
    <!--评价图片预览-->
    <portal to="comment-image-preview" v-if="previewInfo && previewInfo.previewImages">
      <v-image-preview
        ref="imagePreview"
        class="image-preview"
        theme="black"
        :show="showEvaluatePop"
        :images="previewInfo.previewImages"
        :startPosition="previewInfo.startPosition"
        :onClose="onClosePreview"
        @previewToBegin="previewToBegin"
        @previewToEnd="previewToEnd"
        :counter="curCounter"
        @refreshPreviewSlide="caculateCounter"
        v-backFn="{ show: showEvaluatePop, closeFn: 'backClosePreview' }"
      >
        <UserInfo :origin="1" :user-info="evaluateInfo" :isBigPic="true" type="pop" />
      </v-image-preview>
    </portal>
    <!--评价列表-->
    <portal to="evaluate-list" v-if="createList">
      <EvaluateList
        ref="eList"
        @preview="showPop"
        @previewAll="showPopAll"
        @close="backCloseList"
        @updateId="handleUpdateId"
        :isShow="showList"
        :tagId="remarkTagId"
      />
    </portal>
  </div>
</template>

<script>
import { EvaluateList, rate } from './components'
import UserInfo from './components/user-info'
import { app, common } from '@/utils'
import { formatCount } from '@/utils/common'
import { mapGetters, mapMutations } from 'vuex'
import { getRemarkList } from '../../index/api'
import env from 'utils/clientEnv'
function numToStr(num) {
  if (num < 10) {
    return '0' + num
  } else {
    return '' + num
  }
}
export default {
  name: 'EvaluateNew',
  components: {
    UserInfo,
    EvaluateList,
    rate
  },
  filters: {
    formatTime(val) {
      let sec = Math.floor(val / 1000)
      return numToStr(parseInt(sec / 60)) + ':' + numToStr(parseInt(sec % 60))
    },
    formatLabelNum(val){
      return formatCount(val)
    }
  },
  computed: {
    ...mapGetters('detailv3', ['spuId', 'skuId', 'remarkInfo', 'goodsType', 'isLottery']),
    totalNums() {
      return this.totalRemarkNum ? `（${formatCount(this.totalRemarkNum)}）` : ''
    },
    likePercentChange() {
      return this.likePercent
        ? `好评度<span style="color:#F10313;">${this.formateLikePercent(this.likePercent)}%</span>`
        : ''
    },
    /**
     * 当前预览的评价信息
     */
    previewInfo() {
      let remarkItem = this.evaluateInfo
      let config = null
      if (remarkItem) {
        config = {}
        config.previewImages = []
        // 正常评论
        if ((remarkItem.idx === -1 || remarkItem.idx === undefined) && remarkItem.commentListPics) {
          for (let i = 0; i < remarkItem.commentListPics.length; i++) {
            if (i == 0 && remarkItem.commentListPics[i].videoUrl) {
              config.previewImages.push({
                videoUrl: remarkItem.commentListPics[i].videoUrl,
                videoPoster: remarkItem.commentListPics[i].bigPic
              })
            } else {
              config.previewImages.push(remarkItem.commentListPics[i].bigPic)
            }
          }
        } else if (remarkItem.commentAppendDto && remarkItem.commentAppendDto.commentListPics) {
          // 追加评论
          for (let i = 0; i < remarkItem.commentAppendDto.commentListPics.length; i++) {
            config.previewImages.push(remarkItem.commentAppendDto.commentListPics[i].bigPic)
          }
        }
        config.startPosition = remarkItem.startPosition
      }
      return config
    },
    labelsList() {
      return this.labels.filter(el => {
        return el.evaluateNum
      }).slice(0, 6)
    },
    // 会员登记播报内容
    ariaUserLevel() {}
  },
  data() {
    return {
      totalRemarkNum: 0, // 评价数量
      labels: [], // 评价标签
      remarkItemList: [],
      // remarkItem: null, // 评价信息
      remarkPreviewList: [],
      curPreviewIndex: 0,
      showList: false,
      createList: false,
      showEvaluatePop: false,
      curPreviewPageNum: 0,
      curPreviewLastId: '',
      pageSize: 10,
      isPreviewEnd: false,
      curPreviewTag: '',
      remarkTagId: '', // 当前评价标签，用于过滤
      likePercent: '', // 好评度
      curCounter: '', // 当前预览图片位置
      previewCount: 0, // 预览图片张数，无论左右滑动都计算
      previewEnterTime: '', // 预览开始时间
      remarkListEnterTime: '', // 评价列表弹窗开始时间
      evaluateInfo: '', // 评价图片预览信息
      isPreviewAll: false, // 是否预览所有图片
      isAppSupportVideo: !env.isVivoApp || env.isIOSVivoApp || env.appVersion >= 3950, // 判断官网app是否支持评价图片预览
      hasVideo: false, // 评价内容是否有视频
      scrollTop: 0
    }
  },
  created() {
    // this.getRemark()
  },
  watch: {
    remarkInfo: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.init()
        }
      }
    }
  },
  methods: {
    ...mapMutations('detailv3', ['SET_EVALUATION', 'SET_VIDEO_CAN_PLAY_STATE', 'SET_IS_SHOW_REMARK_POPUP']),
    formateLikePercent(value) {
      if (value == 1) {
        return 100
      } else {
        let result = Math.round(value * 1000) / 10
        if (result == 100) {
          return 99.9
        } else {
          return result
        }
      }
    },
    init() {
      const data = this.remarkInfo
      this.totalRemarkNum = data?.tagCommentsAmount
      if (data?.commentDetailsPage?.list?.length) {
        this.remarkItemList = data.commentDetailsPage.list.slice(0, 1)
        this.remarkItemList.forEach(el => {
          el.hasVideo = false
          if (el.commentListPics?.findIndex(v => v.videoUrl) > -1) {
            el.hasVideo = true
          }
        })
      }
      // 用于判断是否需要显示titlebar中的评价、评价气泡
      // this['SET_EVALUATION'](data)
      this.labels = data?.commentLabels || []
      this.likePercent = data?.likePercent
      // 通知App是否显示评价顶部评价tab签
      app.isShowTitlebarComment({ isShow: this.remarkItemList.length })
    },
    showPopClick(index, remarkItem, item) {
      this.scrollTop = window.scrollY
      // 2：点击的视频 3: 点击的图片
      this.allClickTrack(item.videoUrl && this.isAppSupportVideo ? 2 : 3, remarkItem, '', index)
      this.showPop(index, remarkItem, -1)
    },
    /**
     * 显示评价图片预览弹层
     */
    showPop(startPosition, remarkItem, idx) {
      // 追评图片预览
      if (idx !== undefined) {
        this.isPreviewAll = false
        this.curCounter = ''
      }
      remarkItem.startPosition = startPosition
      remarkItem.idx = idx
      this.evaluateInfo = Object.assign({}, remarkItem)
      // 如果是App访问，则使用app的大图预览
      // 客户端预览去掉评价内容富文本的标签
      const clientContent = remarkItem?.content?.replace(/\<span>|\<\/span>|\n|\&nbsp\;/g, '')
      let item = {
        content: clientContent, // remarkItem.content,
        memberAvatar: remarkItem.memberAvatar,
        summaryScore: remarkItem.score,
        createdAt: remarkItem.commentDate,
        createdBy: remarkItem.nickName,
        memberLever: remarkItem.memberLever,
        memberLeverName: remarkItem.memberLeverName,
        specItem: remarkItem.specItem
      }
      if (!app.remarkShowBigImage(this.previewInfo.previewImages, startPosition, item)) {
        this.showEvaluatePop = true
        app.toggleTitleBarNew({
          isShow: false
        })
      }
    },
    /**
     * 显示评价图片预览弹层
     */
    showPopAll(startPosition, remarkItem, curIndex, curTagId, curPageNum, lastId, remarkPreviewList) {
      this.isPreviewAll = true
      this.previewEnterTime = new Date().getTime()
      this.remarkPreviewList = remarkPreviewList
      this.curPreviewIndex = curIndex
      this.curPreviewTag = curTagId
      this.curPreviewPageNum = curPageNum
      this.curPreviewLastId = lastId
      remarkItem.startPosition = startPosition
      delete remarkItem.idx
      this.evaluateInfo = Object.assign({}, remarkItem)
      // 如果是App访问，则使用app的大图预览
      let item = {
        content: remarkItem.content,
        memberAvatar: remarkItem.memberAvatar,
        summaryScore: remarkItem.score,
        createdAt: remarkItem.commentDate,
        createdBy: remarkItem.nickName,
        memberLever: remarkItem.memberLever,
        memberLeverName: remarkItem.memberLeverName,
        specItem: remarkItem.specItem
      }
      this.caculateCounter(startPosition)
      let remarkOption = {
        remarkPreviewList: this.remarkPreviewList,
        tagId: this.curPreviewTag == -1 ? '' : this.curPreviewTag,
        pageNum: this.curPreviewPageNum,
        lastId: this.curPreviewLastId,
        spuId: this.spuId,
        sortOrder: this.curPreviewTag == -1 ? 'desc' : 'hot',
        curCounter: this.curCounter
      }
      if (!app.remarkShowBigImage(this.previewInfo.previewImages, startPosition, item, remarkOption)) {
        this.showEvaluatePop = true
        app.toggleTitleBarNew({
          isShow: false
        })
      }
    },
    // 大图预览上一个评价图片,追评不用查看上一条
    previewToBegin() {
      if (!this.isPreviewAll) {
        return
      }
      if (this.curPreviewIndex > 0) {
        this.curPreviewIndex--
      } else {
        return
      }
      let pos = this.remarkPreviewList[this.curPreviewIndex].commentListPics.length - 1
      this.showPop(pos, this.remarkPreviewList[this.curPreviewIndex])
      this.$refs.imagePreview.refreshPreview(pos)
    },
    // 大图预览下一个评价图片，追评不用查看下一条
    previewToEnd() {
      if (!this.isPreviewAll) {
        return
      }
      if (this.curPreviewIndex == this.remarkPreviewList.length - 1) {
        // 获取下一页有图评价
        this.getNextPreviewList()
        return
      }
      if (this.curPreviewIndex < this.remarkPreviewList.length - 1) {
        this.curPreviewIndex++
      }
      this.showPop(0, this.remarkPreviewList[this.curPreviewIndex])
      this.$refs.imagePreview.refreshPreview(0)
    },
    // 获取下一页有图评价
    getNextPreviewList() {
      if (this.isPreviewEnd) {
        return
      }
      this.curPreviewPageNum++
      let _params = {
        spuId: this.spuId,
        tagId: this.curPreviewTag == -1 ? '' : this.curPreviewTag,
        onlyHasPicture: true,
        lastId: this.curPreviewLastId,
        pageNum: this.curPreviewPageNum,
        pageSize: this.pageSize * 3, // 多请求几页数据，以防评价图片过少
        sortOrder: this.curPreviewTag == -1 ? 'desc' : 'hot'
      }
      getRemarkList(_params).then(data => {
        let nextList = data.commentDetailsPage.list
        let hasNext = data.commentDetailsPage.hasNext
        let filterList = []
        this.curPreviewLastId = data.lastId || ''
        // 服务端返回有图评价列表中可能版本无图评价过滤
        if (nextList && nextList.length > 0) {
          nextList.forEach(item => {
            if (item.commentListPics && item.commentListPics.length > 0) {
              filterList.push(item)
            }
          })
          if (!hasNext) {
            this.isPreviewEnd = true
          }
          if (filterList.length > 0) {
            this.remarkPreviewList = this.remarkPreviewList.concat(filterList)
          } else {
            this.isPreviewEnd = true
          }
          this.previewToEnd()
        } else {
          this.isPreviewEnd = true
        }
      })
    },
    // 计算当前预览图片位置
    caculateCounter(active = 0) {
      this.previewCount++
      if (!this.isPreviewAll) {
        return
      }
      let total = 0
      let countArr = []
      if (this.remarkPreviewList.length == 0) {
        return
      }
      this.remarkPreviewList.forEach(item => {
        if (item.commentListPics && item.commentListPics.length > 0) {
          total += item.commentListPics.length
          countArr.push(item.commentListPics.length)
        }
      })
      // 计算前面所有评价图片数
      let beforeSum = 0
      for (let i = 0; i < countArr.length; i++) {
        if (i < this.curPreviewIndex) {
          beforeSum += countArr[i]
        }
      }
      let activeIndex = beforeSum + active + 1
      if (activeIndex && total) {
        this.curCounter = activeIndex + '/' + total
      }
    },
    /**
     * 显示隐藏评价图片预览弹层
     */
    onClosePreview() {
      this.showEvaluatePop = false
      let previewEndTime = new Date().getTime()
      // 预览停留时长
      let duration = ''
      if (this.previewEnterTime) {
        duration = previewEndTime - this.previewEnterTime
      }
      let logParams = {
        cfrom: '106|001|98|077',
        event_id: '106|001|98|077',
        spu_id: this.spuId
      }
      if (this.isPreviewAll) {
        logParams.picture_qty = this.previewCount || 1
        logParams.duration = duration / 1000
      }
      this.$track(logParams)
      this.remarkPreviewList = ''
      setTimeout(() => {
        this.evaluateInfo = {}
      }, 100)
      this.curPreviewTag = ''
      this.curPreviewIndex = 0
      this.curPreviewLastId = ''
      this.curPreviewPageNum = 0
      this.previewCount = 0
      this.previewEnterTime = ''
      this.isPreviewAll = false
      this.remarkPreviewList = []
      app.toggleTitleBarNew({
        isShow: true
      })
    },
    showListPopup(flag) {
      this.createList = true
      this.showList = flag
    },
    /**
     * 点击埋点
     */
    allClickTrack(comment_content, remarkItem = '', label_name = '', position) {
      // comment_content: 1: 查看全部 2: 视频, 3: 图片, 4:标签
      this.$track({
        cfrom: '157|002|01|077',
        event_id: '157|002|01|077',
        page_name: 1,
        sku_id: this.skuId,
        comment_content: comment_content,
        comment_id: remarkItem?.commentId || '',
        comment_type: remarkItem ? (remarkItem.hasVideo ? 1 : 2) : '',
        tag_content: label_name,
        position
      })
    },
    /**
     * 回退关闭评价列表
     */
    backCloseList() {
      let remarkListEndTime = new Date().getTime()
      // 评价列表弹层停留时长
      let duration = ''
      if (this.remarkListEnterTime) {
        duration = remarkListEndTime - this.remarkListEnterTime
      }
      this.$track({
        cfrom: '105|001|98|077',
        event_id: '105|001|98|077',
        goodstype: this.goodsType,
        sku_id: this.skuId,
        duration
      })
      this.SET_VIDEO_CAN_PLAY_STATE(true)
      this.showListPopup(false)
      this.showEvaluatePop = false
      this.tagId = ''
    },
    // 图片预览关闭
    backClosePreview() {
      this.showEvaluatePop = false
      app.toggleTitleBarNew({
        isShow: true
      })
    },
    // 筛选标签
    filterRemarkList(tagId, label_name, index = 0) {
      this.allClickTrack(4, null, label_name, index)
      this.remarkTagId = tagId
      this.showListPopup(true)
    },
    // 展示评论列表
    showRemarkList(remarkItem = '', index = 0) {
      this.SET_VIDEO_CAN_PLAY_STATE(false)
      this.remarkTagId = ''//v990查看更多清除已选标签
      this.allClickTrack(1, remarkItem, '', index)
      this.remarkListEnterTime = new Date().getTime()
      this.showListPopup(true)
    },
    closeAll() {
      if (this.showEvaluatePop) {
        this.backClosePreview()
      }
      if (this.showList) {
        this.backCloseList()
      }
    },
    handleUpdateId(id) {
      this.remarkTagId = id
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-4 {
  .evaluate-wrap .user-info .detail .level-icon-img {
    height: 39px;
  }
}
.vivo-fontscale-5 {
  .evaluate-wrap .user-info .detail .level-icon-img {
    height: 44px;
  }
}
</style>
